export default class WinData {
	constructor(symbols, freeSpins, pay) {
		this.symbols = symbols;
		this.freeSpins = freeSpins;
		this.pay = pay;
	}

	symbolsToString() {
		if (this.symbols == null) return '';
		var ss = '';
		this.symbols.forEach(item => {
			ss += item !== null && item.sprite !== null ? item.sprite.name : '?';
		});
		return ss;
	}

	toString() {
		return this.symbolsToString() + '\n' + 'Pay: ' + this.pay + '; FreeSpin: ' + this.freeSpins;
	}
}
